import {Search} from '../../FormHeader/components/Search';
import {Column} from '../../Form/serializers/column';
import withClickOutside from 'react-onclickoutside';

export const ColumnsSearch = withClickOutside(Search.ofType<Column>());
